import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICanalesCamara } from 'modelos/src';

@Component({
  selector: 'app-detalles-canales-camaras',
  templateUrl: './detalles-canales.component.html',
  styleUrl: './detalles-canales.component.scss',
  standalone: false,
})
export class DetallesCanalesCamarasComponent {
  data = inject<ICanalesCamara>(MAT_DIALOG_DATA);
  dialogRef =
    inject<MatDialogRef<DetallesCanalesCamarasComponent>>(MatDialogRef);
}
